import { call, put, takeLatest } from 'redux-saga/effects';
import { navigate } from 'gatsby-link';
import { createFlashMessage } from '../components/Flash/redux';
import {
  deleteMessageById,
  getMessageListForUser,
  getMessages,
  postCreateMessage,
  postUpdateMessage,
  postUploadImage
} from '../utils/ajax';
import { actionTypes } from './action-types';

function* submitCreateMessage({ payload }) {
  try {
    if (payload.image?.lastModified) {
      const result = yield call(postUploadImage, payload.image);
      if (!result.data.success) {
        throw new Error(result.data.message);
      }
      payload.image = result.data.result.metadata;
    }

    const { data } = yield call(postCreateMessage, payload);

    if (data?.result?.success) {
      yield put(
        createFlashMessage({
          type: 'success',
          message: data.result.message,
          variables: { dismissible: true }
        })
      );
      void navigate('/admin/messages-managment');
    } else {
      yield put(
        createFlashMessage({
          type: 'danger',
          message: data.message,
          variables: { dismissible: true }
        })
      );
    }
  } catch (e) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
    yield put({ type: actionTypes.createMessageError });
  } finally {
    yield put({ type: actionTypes.createMessageComplete });
  }
}

function* submitUpdateMessage({ payload }) {
  try {
    let formattedPayload = payload;

    if (payload.image?.lastModified) {
      const result = yield call(postUploadImage, payload.image);
      if (!result.data.success) {
        throw new Error(result.data.message);
      }
      formattedPayload.image = result.data.result.metadata;
    } else if (payload.image?.name) {
      delete formattedPayload.image;
    } else {
      formattedPayload.image = null;
    }

    const { data } = yield call(postUpdateMessage, formattedPayload);

    if (data?.result?.success) {
      yield put(
        createFlashMessage({ type: 'success', message: data.result.message })
      );
      void navigate('/admin/messages-managment');
    } else {
      yield put(createFlashMessage({ type: 'danger', message: data.message }));
    }
  } catch (e) {
    console.log('error', e);
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.'
      })
    );
    yield put({ type: actionTypes.updateMessageError });
  } finally {
    yield put({ type: actionTypes.updateMessageComplete });
  }
}

function* fetchMessagesForUser({ payload }) {
  try {
    const { messageList } = yield call(getMessageListForUser, payload);

    yield put({
      type: actionTypes.fetchMessagesComplete,
      payload: messageList
    });
  } catch (e) {
    console.log('error', e);

    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.'
      })
    );
  }
}

function* fetchMessagesForAdmin({ payload }) {
  try {
    const messagePayload = yield call(getMessages, { filter: payload });

    yield put({
      type: actionTypes.fetchMessagesForAdminComplete,
      payload: messagePayload
    });
  } catch (e) {
    console.log('error', e);

    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.'
      })
    );
  }
}

function* submitDeleteMessage({ payload }) {
  try {
    const { data } = yield call(deleteMessageById, payload.id);
    const count = data.result.count;

    if (count > 0) {
      yield put(
        createFlashMessage({
          type: 'success',
          message: 'Mensagem excluída com sucesso!',
          variables: { dismissible: true }
        })
      );
      yield put({
        type: actionTypes.fetchMessagesForAdmin,
        payload: payload.filter
      });
    } else {
      yield put(
        createFlashMessage({
          type: 'danger',
          message: 'Não foi possível excluir a mensagem.',
          variables: { dismissible: true }
        })
      );
    }
  } catch (e) {
    console.log('error', e);
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* uploadImage({ payload }) {
  try {
    const { data } = yield call(postUploadImage, payload);
    if (data?.result?.success) {
      yield put({
        type: actionTypes.uploadImageComplete,
        payload: data.result
      });
    } else {
      yield put(createFlashMessage({ type: 'danger', message: data.message }));
    }
  } catch (e) {
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.'
      })
    );
  }
}

export function createMessageSaga(types) {
  return [
    takeLatest(types.createMessage, submitCreateMessage),
    takeLatest(types.updateMessage, submitUpdateMessage),
    takeLatest(types.deleteMessage, submitDeleteMessage),
    takeLatest(types.fetchMessages, fetchMessagesForUser),
    takeLatest(types.fetchMessagesForAdmin, fetchMessagesForAdmin),
    takeLatest(types.uploadImage, uploadImage)
  ];
}
